import React from 'react';
import { useParams } from 'react-router-dom';

const CourseDetail = () => {
  const { id } = useParams();

  const courseData = {
    1: {
      title: 'NEET Preparation Course',
      subtitle: 'Class 11th, 12th, Repeater',
      price: '₹25,000',
      duration: '1 Year',
      icon: '🏥',
      image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&h=400&fit=crop',
      description: 'Comprehensive NEET preparation program designed to help you secure admission to top medical colleges.',
      features: [
        'Live & Recorded Classes by Expert Faculty',
        '3500+ Chapter-wise Tests and Mock Exams',
        'Comprehensive Study Material',
        'Doubt Solving Sessions',
        'All India Test Series',
        'Performance Analytics',
        '24/7 Support',
        'Previous Year Question Papers',
      ],
      syllabus: [
        'Physics: Mechanics, Thermodynamics, Waves, Electrostatics, Current Electricity',
        'Chemistry: Physical, Organic, Inorganic Chemistry',
        'Biology: Botany and Zoology',
      ],
      schedule: 'Classes: Mon-Fri (4:00 PM - 7:00 PM), Sat (Test Day)',
    },
    2: {
      title: 'JEE Preparation Course',
      subtitle: 'Class 11th, 12th',
      price: '₹30,000',
      duration: '1 Year',
      icon: '⚡',
      image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800&h=400&fit=crop',
      description: 'Focused JEE Main & Advanced preparation with strong concept building and problem-solving skills.',
      features: [
        'Expert Faculty with IIT Background',
        'Concept Building Sessions',
        'Problem Solving Workshops',
        'Mock Tests and Practice Papers',
        'Doubt Solving Sessions',
        'Study Material and Notes',
        'Performance Tracking',
        'Previous Year Papers',
      ],
      syllabus: [
        'Physics: All JEE Syllabus',
        'Chemistry: Physical, Organic, Inorganic',
        'Mathematics: Algebra, Calculus, Geometry',
      ],
      schedule: 'Classes: Mon-Fri (4:00 PM - 7:00 PM), Sat (Test Day)',
    },
  };

  const course = courseData[id] || courseData[1];

  return (
    <div className="py-16 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="relative h-64 md:h-96">
            <img
              src={course.image}
              alt={course.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
              <div className="text-center text-white">
                <div className="text-6xl mb-4">{course.icon}</div>
                <h1 className="text-4xl md:text-5xl font-bold mb-2">{course.title}</h1>
                <p className="text-xl">{course.subtitle}</p>
              </div>
            </div>
          </div>

          <div className="p-8">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Course Description</h2>
                <p className="text-gray-600 mb-6">{course.description}</p>

                <h3 className="text-xl font-bold text-gray-900 mb-4">Key Features</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  {course.features.map((feature, index) => (
                    <div key={index} className="flex items-start">
                      <span className="text-green-500 mr-2 mt-1">✓</span>
                      <span className="text-gray-600">{feature}</span>
                    </div>
                  ))}
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-4">Syllabus Coverage</h3>
                <div className="space-y-2 mb-6">
                  {course.syllabus.map((topic, index) => (
                    <div key={index} className="flex items-start">
                      <span className="text-primary mr-2 mt-1">•</span>
                      <span className="text-gray-600">{topic}</span>
                    </div>
                  ))}
                </div>

                {/* <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Class Schedule</h4>
                  <p className="text-gray-600">{course.schedule}</p>
                </div> */}
              </div>

              <div>
                <div className="bg-gray-50 p-6 rounded-lg sticky top-4">
                  <h3 className="text-xl font-bold text-gray-900 mb-4">Course Details</h3>
                  {/* <div className="space-y-4 mb-6">
                    <div>
                      <span className="text-sm text-gray-500">Duration</span>
                      <div className="text-lg font-semibold">{course.duration}</div>
                    </div>
                    <div>
                      <span className="text-sm text-gray-500">Price</span>
                      <div className="text-2xl font-bold text-primary">{course.price}</div>
                    </div>
                  </div> */}
                  
                  <div className="space-y-3">
                    <button className="w-full bg-primary text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-semibold">
                      Contact Us
                    </button>
                    <button className="w-full border-2 border-primary text-primary px-6 py-3 rounded-lg hover:bg-primary hover:text-white transition-colors font-semibold">
                      Get Free Demo
                    </button>
                  </div>
                  
                  <div className="mt-6 pt-6 border-t border-gray-200">
                    <h4 className="font-semibold text-gray-900 mb-2">Contact Us</h4>
                    <p className="text-sm text-gray-600 mb-2">📞 +91-94047 95121</p>
                    <p className="text-sm text-gray-600">📍 Majalgaon, Maharashtra 431131</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetail;